import React, { Component } from 'react';
import { List, Button } from 'semantic-ui-react';
import { timeDifferenceForDate } from '../utils';
import moment from 'moment';

class SubscriberEntry extends Component {
  render() {
    const { subscriber, showDeleteModal, showEditModal } = this.props;
    return (
      <List.Item>
        <List.Content floated="right">
          <Button icon="edit" size="medium" onClick={showEditModal.bind(this, subscriber)} />
          <Button
            icon="trash"
            size="medium"
            onClick={showDeleteModal.bind(this, subscriber)}
          />
        </List.Content>
        <List.Icon name="mail" size="big" verticalAlign="top" color="blue" />
        <List.Content>
          <List.Header>{subscriber.email}</List.Header>
          <List.Description>
            {moment(subscriber.createdAt).format('YYYY/MM/DD')}
            {' - '}
            {timeDifferenceForDate(moment(subscriber.createdAt).valueOf())} ({
              subscriber.status
            })
          </List.Description>
        </List.Content>
      </List.Item>
    );
  }
}

export default SubscriberEntry;



// WEBPACK FOOTER //
// ./src/components/SubscriberEntry.js